const pageData = [
  {
    title: "<h1>What is Postiva Fungicide?</h1>",
    label: "What is Postiva <br/>Fungicide?",
    template: "video",
    content:
      "<p>Postiva<sup>™</sup> fungicide is the most recent innovation from Syngenta for reliable, long-lasting disease control. Postiva is powered by ADEPIDYN<sup>®</sup> technology and <span class='italic'>difenoconazole</span> in FRAC Groups 7 and 3. With two modes of action, Postiva provides strong protection and control of many difficult diseases.</p>",
    videoId: "wEQ-QcAmHaU",
  },
  {
    title: "<h2>Features and Benefits of Postiva</h2>",
    label: "Features and <br/>Benefits",
    template: "banner-and-carousel",
    bannerImage: "/images/Gettyimages-615076240-cropped.jpg",
    carousel: [
      {
        title: "Features",
        content: [
          "Features a combination unique to the ornamental market in FRAC Groups 7 and 3",
          "Rapidly absorbed into plant tissue creating a rainfast barrier of protection; <span class='bold italic'>preventing infection and disease progression</span>",
          "Provides bacterial disease suppression of <span class='italic'>Pseudomonas</span> spp. and <span class='italic'>Xanthomonas</span> spp.",
          "Applications can be made by spray, drench, chemigation or cold fogging",
        ],
      },
      {
        title: "Benefits",
        content: [
          "Excellent rotation partner to diversify programs for more comprehensive and broader-spectrum disease control",
          "Outstanding efficacy and long-lasting control of <span class='italic'>Fusarium</span> spp., powdery mildews and leaf spot diseases",
          "Provides a complete plant-protection treatment against fungal and bacterial pathogens",
          "Flexible application methods fit for any operation",
        ],
      },
    ],
  },
  {
    title: "<h2>Modes of Action: ADEPIDYN Technology</h2>",
    label: "Modes of Action: <br/>ADEPIDYN Technology",
    template: "video-with-carousel",
    content:
      "<p>ADEPIDYN technology was developed by Syngenta as the first member of a new subclass of SDHIs (succinate dehydrogenase inhibitors). It is a pyrazole carboxamide in FRAC Group 7 that features a unique molecule designed to combine the best features of carboxamide fungicides for broader activity and longer residual control.</p><p>Upon application, ADEPIDYN technology moves quickly from the leaf surface into the wax layer, becoming rainfast and creating a layer of protection. Within 24 hours, it begins to penetrate and spread within the plant tissue to provide systemic disease control. ADEPIDYN technology works to inhibit energy production within the fungal pathogen, preventing spore germination, penetration and mycelial growth.</p>",
    videoId: "yLsUWGllsgQ",
    carouselContent: {
      title: "Physiological MoA of SDHIs",
      content:
        "At 0.0046 ppm, ADEPIDYN technology shows greater inhibition of <span class='italic'>Botrytis cinerea conidia</span> spore germination compared to other SDHI fungicide treatments.",
    },
    carousel: [
      {
        image: "ADEPIDYN-technology.jpg",
      },
      {
        image: "Boscalid.jpg",
      },
      {
        image: "Carboxin.jpg",
      },
      {
        image: "Fluopyram.jpg",
      },
      {
        image: "Check.jpg",
      },
    ],
  },
  {
    title:
      "<h2>Modes of Action: <span class='italic'>Difenoconazole</span></h2>",
    label: "Modes of Action: <br /><span class='italic'>Difenoconazole</span>",
    template: "video",
    content:
      "<p><span class='italic'>Difenoconazole</span> is a demethylation inhibitor (DMI) in FRAC Group 3. It prevents the production of ergosterol in the cell membrane from being incorporated, causing cell walls to weaken and collapse. As a triazole, it has systemic and curative properties. It has a strong affinity to the wax layer of plants, which can lead to longer residual control. <span class='italic'>Difenoconazole</span> offers curative activity by preventing germ tube elongation and mycelial growth, limiting disease development and sporulation.</p>",
    videoId: "pjhSA58-1A0",
  },
  {
    title: "<h2>Mobility of Postiva Fungicide</h2>",
    label: "Mobility of <br/>Postiva Fungicide",
    template: "content-with-two-columns",
    content:
      "<p>The Carbon-14 labeled micrographs illustrate the movement of each active ingredient in Postiva when applied to a leaf or apical bud.</p>",
    moreInfo: {
      left: {
        title: "Foliar Application",
        content:
          "This fungicide shows steady redistribution in the leaf after application to the foliage.",
        image: "Foliar_App.jpg",
      },
      right: {
        title: "Apical Bud Application",
        content:
          "Applications absorbed by the petiole and apical bud result in the upward systemic movement of the fungicide, protecting new tissue.",
        image: "Apical_App.jpg",
      },
    },
  },
  {
    title: "<h2>Which Diseases Does Postiva Control?</h2>",
    label: "Disease <br/>Control",
    template: "list-with-carousel",
    content:
      "<p>Postiva delivers long-lasting protection against the most challenging foliar and soilborne diseases, such as:</p>",
    list: [
      "Botrytis",
      "Powdery mildews",
      "Black spot",
      "Leaf spots, including <span class='italic'>Anthracnose, Alternaria, Cercospora, Septoria spp</span>.",
      "<span class='italic'>Fusarium, Rhizoctonia, Sclerotinia spp</span>.",
      "Rusts",
      "Boxwood blight",
      "Bacterial disease (suppression)",
    ],
    carousel: [
      {
        title:
          "Control of <span class='italic'>Fusarium</span> Crown Rot on Cyclamen",
        image: "Cyclamen.jpg",
        caption:
          "2018 – Elmer, Connecticut Ag Experiment Station, Rates per 100 gal. Treatments applied as a sprench 100 ml over top of the plants. Eight single plant replicates.",
      },
      {
        title:
          "Control of <span class='italic'>Fusarium Wilt</span> on Garden Mums",
        image: "Images_GardenMums.jpg",
        caption:
          "2019 – Norman, University of FL. Rates per 100 gal. Treatments applied 9/18 & 10/2 as a sprench 100 ml over top of the plants. Ten single plant replicates.",
      },
      {
        title: "Dogwood – Septoria Leaf Spot (3 weeks after last treatment)",
        image: "Images_Dogwood.jpg",
        caption:
          "2019 – Beckerman & Haas, Purdue University. Rates per 100 gal. Treatments applied May 16, 28, June 12, Jul 3. CapSil<sup>®</sup> applied with all treatments at 6 fl. oz./100 gal.",
      },
      {
        title:
          "Control of <span class='italic'>Xanthamonas</span> Leaf Spot on Zinnia",
        image: "Zinnia.jpg",
        caption:
          "2019 – Krasnow, VBRC. Rates listed per 100 gal. Two foliar sprays applied on 7-day interval. Plants were inoculated 2 days after first application.",
      },
      {
        title: "Control of Blackspot (Diplocarpon rosae) on Rose",
        image: "Rose.jpg",
        caption:
          "2018 – Krasnow, VBRC. Treatments applied twice on a 14-day interval. Rates per 100 gal.",
      },
      {
        title: "Control of Botrytis on Geranium ‘Pinto Premium Pink’",
        image: "Geranium.jpg",
        caption:
          "2019 – Hausbeck & Harlan, MSU. Treatments applied 9/6 & 9/13. Plants inoculated 9/9. Rates per 100 gal.",
      },
      {
        title: "Control of Gerbera Daisy Powdery Mildew",
        image: "GerberaDaisy.jpg",
        caption:
          "2018 – Krasnow, VBRC. Treatments applied two times on a 14-day interval. Rates per 100 gal.",
      },
    ],
  },
  {
    title: "<h2>Application Sites and Use Recommendations</h2>",
    label: "Application Sites <br/>and Uses",
    template: "content-with-image",
    content:
      "<p>Postiva can be applied on ornamental crops, vegetable plants grown for retail sales and non-bearing fruit and nut plants.</p>",
    sectionOne: {
      listTitle: "Use rates: 10-28 fl. oz./100 gal. (Spray or Drench)",
      list: [
        'Spray applications can be made on a 7 to 14-day interval. <span class="bold italic">Treatment of most foliar diseases can be made on a 14-day interval</span>.',
        "Drench applications can be made to container grown ornamentals.",
      ],
    },
    sectionTwo: {
      listTitle: "Postiva can be applied in: ",
      list: [
        "Greenhouses",
        "Nurseries, including field- and container-grown plants",
        "Conifer nurseries",
        "Residential and commercial landscapes",
      ],
    },
    image: "Gettyimages-533434786-cropped.jpg",
  },
  {
    title: "<h2>Perfect Your Program With Postiva</h2>",
    label: "Perfect Your <br/>Program",
    template: "content-with-image",
    content:
      "<p>Fungal pathogens can develop resistance to products with the same mode of action when used repeatedly.</p>",
    sectionOne: {
      content:
        "<p>With two modes of action, Postiva offers a strong defense against multiple pathogens while helping delay the development of resistance. Use Postiva in rotation with Mural<sup>®</sup> (FRAC Group 7+11), Palladium<sup>®</sup> (FRAC group 9+12) and Daconil<sup>®</sup> (FRAC Group M) brand fungicides to create a robust disease and resistance management program. Rotating these fungicides gives you the power of six modes of action with proven activity on numerous pathogens.</p>",
    },
    sectionTwo: {
      title: "Postiva Fungicide Recap",
      content:
        "<p>Postiva is a strong addition into greenhouse and nursery fungicide rotation programs. With two active ingredients in FRAC Groups 7 and 3, it is a powerful resistance management tool. It has proven to provide broad-spectrum control of leaf spots, flower blights, powdery mildew, soilborne diseases such as <span class='italic'>Fusarium</span> spp., and many more. It can be applied as a spray to vegetable plants and as a spray or drench to ornamentals and non-bearing fruit and nut plants.</p>",
    },
    image: "Gettyimages-155285202-cropped.jpg",
  },
  {
    title: "<h2>Postiva Fungicide Learning Module Quiz</h2>",
    label: "Take <br/>the Quiz",
    template: "quiz",
    content:
      "<p>Thank you completing the Postiva learning module. Be one of the first 150 people to complete this quiz to receive a free cooler backpack.</p>",
  },
];

export default pageData;
